import { render, staticRenderFns } from "./HistoryPanel.vue?vue&type=template&id=67e2d0c4"
import script from "./HistoryPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports